/**
 * Given an array and a conditional funciton, returns 2 arrays, one of elements that passed, one of elements that fail
 * @param array Array of something we want to run a conditional on
 * @param isValid A function we want to run against each thing in the array
 * @returns 2 arrays, one filled with the elements that passed the function, the other with the fails
 */
export function divideInto2Arrays<T>(array: T[], isValid: (element: T) => boolean): [T[], T[]] {
	return array.reduce(
		([pass, fail]: [T[], T[]], elem) => {
			return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
		},
		[[], []],
	);
}
